import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/Modal/index'
import ReactHtmlParser from 'react-html-parser'
import TextField from '../TextField'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import moment from 'moment'

const CSV_DELIMITER = ','

class UploadModal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    file: PropTypes.any,
    currentItem: PropTypes.object,
    toggleUpload: PropTypes.func,
    validateProducts: PropTypes.func,
    productsValidation: PropTypes.any,
    onSubmit: PropTypes.func,
  }

  state = {
    values: {
      idInventoryCriteria: '',
      dsListName: '',
      listRegionsAndBranchs: [],
      inAllBranchs: 0,
      qtItemsInList: '',
      validity: [],
      inProductsList: 1,
      listProducts: [],
    },
    loading: true,
    validationStatus: 'idle',
    allBranchOptions: [],
  }

  validationController = null

  isUnmounted = false

  componentDidMount() {
    this.isUnmounted = false
    const { file, currentItem } = this.props

    if (file) {
      this.handleFile()
    } else if (currentItem) {
      this.fetchList(currentItem.idInventoryCriteria)
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true
    this.abortValidation()
  }

  abortValidation = () => {
    if (this.validationController) {
      this.validationController.abort()
      this.validationController = null
    }
  }

  fillFields(list) {
    const { values } = this.state

    list.listRegionsAndBranchs.forEach((l) => {
      l.value = l.idBranchOrRegion
      l.isBranch = 1
    })

    if (list) {
      values.idInventoryCriteria = list.idInventoryCriteria
      values.dsListName = list.dsListName
      values.listRegionsAndBranchs = list.listRegionsAndBranchs
      values.inAllBranchs = list.inAllBranchs || 0
      values.qtItemsInList = list.qtItemsInList
      values.validity = [moment(list.dtBegin), moment(list.dtEnd)]
    }

    this.setState({ values })
  }

  fetchList = async (idInventoryCriteria) => {
    const { user, toggleUpload } = this.props

    if (user) {
      this.setState({ loading: true })
      const query = { idInventoryCriteria }

      try {
        const { data } = await new Api(user.dsToken).get(
          API_URL.INVENTORY_CRITERIA_FETCH_ID,
          query
        )
        this.fillFields(data)
      } catch (error) {

        toggleUpload(false)
      } finally {
        this.setState({ loading: false })
      }
    }
  }

  handleFile = () => {
    const { file, toggleUpload } = this.props

    if (file instanceof Blob) {
      const dsListName = file.name || ''

      this.handleChange('dsListName', dsListName)
      this.beforeValidateProducts(file)
    } else {
      toggleUpload(false)
    }
  }

  beforeValidateProducts = (file) => {
    const {
      user: { dsToken },
      validateProducts,
    } = this.props

    const reader = new FileReader()

    const onLoad = async () => {
      const listProducts = reader.result
        .split(CSV_DELIMITER)
        .reduce((list, lm) => {
          const numberList = lm.match(/\d+/)
          if (numberList) {
            list.push({ cdLm: numberList[0] })
          }

          return list
        }, [])

      this.abortValidation()
      this.setState((prevState) => ({
        loading: true,
        validationStatus: 'loading',
        values: {
          ...prevState.values,
          listProducts: [],
        },
      }))

      const controller = new AbortController()
      this.validationController = controller

      const handleAbort = () => {
        if (this.validationController !== controller) {
          return
        }

        if (controller.signal && controller.signal.removeEventListener) {
          controller.signal.removeEventListener('abort', handleAbort)
        } else {
          controller.signal.onabort = null
        }

        this.validationController = null

        if (!this.isUnmounted) {
          this.setState({ loading: false, validationStatus: 'cancelled' })
        }
      }

      if (controller.signal && controller.signal.addEventListener) {
        controller.signal.addEventListener('abort', handleAbort)
      } else {
        controller.signal.onabort = handleAbort
      }

      const onSuccess = (data) => {
        if (this.isUnmounted || this.validationController !== controller) {
          return
        }

        if (controller.signal && controller.signal.removeEventListener) {
          controller.signal.removeEventListener('abort', handleAbort)
        } else {
          controller.signal.onabort = null
        }

        this.validationController = null
        this.setState((prevState) => ({
          loading: false,
          validationStatus: 'success',
          values: {
            ...prevState.values,
            listProducts: (data && data.listProducts) || [],
          },
        }))
      }

      try {
        await validateProducts(dsToken, listProducts, onSuccess, controller)
      } catch (error) {
        const isAbortError =
          (error && error.name === 'AbortError') ||
          (controller.signal && controller.signal.aborted)

        if (isAbortError) {
          handleAbort()
          return
        }

        if (controller.signal && controller.signal.removeEventListener) {
          controller.signal.removeEventListener('abort', handleAbort)
        } else {
          controller.signal.onabort = null
        }

        if (this.isUnmounted || this.validationController !== controller) {
          return
        }

        this.validationController = null
        this.setState({ loading: false, validationStatus: 'error' })
      }
    }

    reader.onload = onLoad
    reader.readAsText(file)
  }

  handleChange = (name, value) => {
    const { values } = this.state

    values[name] = value

    this.setState({ values })
  }

  canSubmit() {
    const { values } = this.state
    let disabled = false

    const toValidate = [
      'dsListName',
      'validity',
      'listRegionsAndBranchs',
      'qtItemsInList',
    ]

    for (const field of toValidate) {
      if (
        (Array.isArray(values[field]) && values[field].length === 0) ||
        !values[field]
      ) {
        disabled = true
      }
    }

    if (this.isLmListEmpty()) disabled = true

    return disabled
  }

  isLmListEmpty() {
    const { values } = this.state

    if (Boolean(values.inProductsList) && !values.listProducts.length) return true
    return false
  }

  renderNotification = () => {
    const { loading, validationStatus } = this.state
    const { productsValidation } = this.props

    const hasErrorList =
      productsValidation.validated.lmErrorList &&
      !!productsValidation.validated.lmErrorList.length

    const getProductsValidationMessage = () => {
      const { translate } = this.props

      if (validationStatus === 'cancelled') {
        return `<p>${translate('irc.upload.cancelled')}</p>`
      }

      if (this.isLmListEmpty()) {
        return `<p>${translate('irc.productsValidationMessage.3')}</p>`
      }

      if (hasErrorList) {
        let message = `<p>${translate('irc.productsValidationMessage.1')}</p>`
        message += `<p>${productsValidation.validated.lmErrorList.join(
          ', '
        )}</p>`
        message += `<p>${translate('irc.productsValidationMessage.2')}</p>`
        return message
      }

      return productsValidation.error
    }

    const shouldShowAlert =
      !loading &&
      (validationStatus === 'cancelled' ||
        hasErrorList ||
        productsValidation.error ||
        this.isLmListEmpty())

    if (shouldShowAlert) {
      return (
        <div className='alert-box margin-bottom'>
          <i className='glyph glyph-exclamation-mark' />
          {ReactHtmlParser(getProductsValidationMessage())}
        </div>
      )
    }
  }

  onSubmit = () => {
    const { toggleUpload, onSubmit } = this.props

    const { values } = this.state

    values.dtBegin = values.validity[0].format()
    values.dtEnd = values.validity[1].format()

    const { allBranchOptions } = this.state
    const expandedBranches = []
    
    values.listRegionsAndBranchs.forEach((item) => {
      if (item.isBranch === true || item.isBranch === 1) {
        expandedBranches.push(item)
      } else if (item.idBranches && Array.isArray(item.idBranches)) {
        item.idBranches.forEach((branchId) => {
          const branchOption = allBranchOptions.find(
            opt => opt.isBranch && opt.value === branchId
          )
          
          expandedBranches.push({
            value: branchId,
            idBranchOrRegion: branchId,
            dsBranchOrRegion: branchOption ? branchOption.label : branchId,
            isBranch: 1,
            idRegion: item.value
          })
        })
      }
    })

    values.listRegionsAndBranchs = expandedBranches

    toggleUpload(false)

    onSubmit(values)
  }

  render() {
    const { toggleUpload, user, translate, file, currentItem } = this.props
    const { values, loading, validationStatus } = this.state

    return (
      <Modal
        isOpen
        disabledBgClickClosing
        title={
          file
            ? translate('irc.upload.title')
            : translate('irc.upload.title.edit')
        }
        className='irc-upload-modal'
        confirmButtonText={translate('register_button')}
        cancelButtonText={translate('close')}
        size={'md'}
        onCloseModal={() => toggleUpload(false)}
        onConfirm={this.onSubmit}
        isConfirmButtonDisabled={this.canSubmit()}
      >
        {file && this.renderNotification()}

        {file  && (
          <div
            className={`loading-status margin-bottom ${!loading ? 'full' : ''}`}
          >
            <span>
              {loading
                ? translate('irc.upload.loading')
                : validationStatus === 'cancelled'
                ? translate('irc.upload.cancelled')
                : translate('irc.upload.loading-full')}
            </span>
            <div className='bar' />
          </div>
        )}

        <div className='w-100'>
          <TextField
            required
            label={translate('irc.name')}
            placeholder={translate('irc.choose-name')}
            name={'dsListName'}
            fill
            onChange={(e) => this.handleChange('dsListName', e.target.value)}
            translate={translate}
            value={values.dsListName}
            validateValue={(v) => Boolean(v)}
          />
        </div>

        <div className='w-100'>
          <RegionBranchMultipleSelect
            required
            name='listRegionsAndBranchs'
            label={translate('irc.store')}
            placeholder={translate('irc.choose-store')}
            user={user}
            translate={translate}
            onChange={(e) => {
              this.handleChange('listRegionsAndBranchs', e.target.value)
            }}
            value={values.listRegionsAndBranchs}
            getAllBranchs={(options) => {
              this.setState({ allBranchOptions: options })
            }}
            excludeInactive={true}
          />
        </div>

        <div className='w-100'>
          <TextField
            required
            label={translate('irc.qt-items-in-list')}
            placeholder={translate('irc.choose-qt-items-in-list')}
            name={'qtItemsInList'}
            fill
            onChange={(e) => this.handleChange('qtItemsInList', e.target.value)}
            mask={'99999999'}
            translate={translate}
            value={values.qtItemsInList}
            validateValue={(v) => v && v.length > 0}
          />
        </div>

        <div className='w-100'>
          <NewDateIntervalInput
            label={translate('irc.validity')}
            required
            initialValue={values.validity.length > 0 ? values.validity : false}
            name={'validity'}
            t={translate}
            onChange={(e) => this.handleChange('validity', e)}
            noSelect
            disableAutoClose
            minDate={
              currentItem && values.validity.length > 0
                ? values.validity[0].toDate()
                : new Date()
            }
          />
        </div>
      </Modal>
    )
  }
}

export default UploadModal
export { UploadModal }